import type { SqlEngine } from '../model';
import { projectCodeOnly, type CodeProjection } from './codeProjection';

/**
 * Safety callers do not own the executing pooled session's sql_mode. Check
 * every MySQL quote interpretation: default, NO_BACKSLASH_ESCAPES (with or
 * without ANSI_QUOTES), and ANSI_QUOTES alone. The latter keeps single-quote
 * escapes but disables them inside double-quoted identifiers.
 *
 * Keep ambiguous projections too: a malformed final statement must not hide
 * an earlier statement the server can execute in a multi-statement request.
 * Without a backslash the projections have identical boundaries.
 */
export function safetyProjections(sql: string, engine: SqlEngine): CodeProjection[] {
  const ordinary = projectCodeOnly(sql, engine);
  return engine === 'mysql' && sql.includes('\\')
    ? [ordinary,
      projectCodeOnly(sql, engine, { mysqlNoBackslashEscapes: true }),
      projectCodeOnly(sql, engine, { mysqlAnsiQuotes: true })]
    : [ordinary];
}
